"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.IconName = exports.IconSize = void 0;
var IconSize;
(function (IconSize) {
    IconSize["TINY"] = "16";
    IconSize["SMALL"] = "24";
    IconSize["MEDIUM"] = "32";
    IconSize["LARGE"] = "48";
    IconSize["X_LARGE"] = "72";
})(IconSize || (exports.IconSize = IconSize = {}));
var IconName;
(function (IconName) {
    IconName["CARET_RIGHT"] = "caret_right";
    IconName["CARET_UP"] = "caret_up";
    IconName["CARET_DOWN"] = "caret_down";
    IconName["CARET_LEFT"] = "caret_left";
    IconName["CHEVRON_DOWN"] = "chevron_down";
    IconName["CHEVRON_LEFT"] = "chevron_left";
    IconName["CHEVRON_RIGHT"] = "chevron_right";
    IconName["CHEVRON_UP"] = "chevron_up";
    IconName["NOTIFICATION_ON"] = "notifications_on";
    IconName["NOTIFICATION_ON_OUTLINED"] = "notifications_on_outlined";
    IconName["NOTIFICATIONS_OUTLINED"] = "notifications_outlined";
    IconName["ERROR_OUTLINED"] = "error_outlined";
    IconName["MESSAGE_FAILED"] = "message_failed";
    IconName["MESSAGE_FAILED_OUTLINED"] = "message_failed_outlined";
    IconName["WARNING"] = "warning";
    IconName["WARNING_OUTLINED"] = "warning_outlined";
    IconName["DRAG"] = "drag";
    IconName["DELETE"] = "delete";
    IconName["DONE"] = "done";
    IconName["CLEAR"] = "clear";
    IconName["PLUS"] = "plus";
    IconName["MORE_VERTICAL"] = "more_vertical";
    IconName["INFO"] = "info";
    IconName["CHECK_MARK_CIRCLE_FILLED"] = "checkmark_circle_filled";
    IconName["CHECK_MARK_CIRCLE_OUTLINED"] = "checkmark_circle_outlined";
    IconName["GAP"] = "gap";
    IconName["INFO_FILLED"] = "info_filled";
})(IconName || (exports.IconName = IconName = {}));
